﻿import { GuiListGeneric } from "../GuiListGeneric";
 
export class GuiListAuftragnehmer extends GuiListGeneric {

    constructor() { 
        super("Auftragnehmer");
    }
}
